
import { ArticleData } from "./types";

export const userBehaviourSequence: ArticleData = {
  id: 4,
  slug: "user-behaviour-sequence-modelling",
  title: "On-the-Fly Personalization: Lessons from Meta's User Behavior Modeling",
  author: "Bharathi Thangamani",
  publishDate: "May 3, 2025",
  lastUpdated: "May 8, 2025",
  category: "ML System Design",
  readTime: "12 min read",
  readCount: 12,
  likeCount: 5,
  isPremium: false,
  contentType: "markdown",
  description: "Learn about in-session adaptation techniques through user behavior sequence modeling for recommendation systems.",
  tags: ["transformer-based sequence models", "in-session adaptation", "user behavior analysis"],
  contentPath: "/docs/insession.md",
  featured: true,
  images: {
    image2: "https://res.cloudinary.com/dvxgyuvxl/image/upload/v1746997050/kuaishou_t30vr7.png"
  }
};
